import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import globalState from 'recoil/atom';
import Calendar from './Calendar';

const Main = () => {
  const setGlobalAtom = useSetRecoilState(globalState);

  useEffect(() => {
    setGlobalAtom(DATA.data);
  }, []);

  return (
    <Wapper>
      <Calendar />
    </Wapper>
  );
};

export default Main;

const Wapper = styled.div`
  max-width: 1256px;
`;

const DATA = {
  data: [
    {
      id: 220101,
      user_name: '홍길동',
      user_phone: '010-3286-6377',
      booking_date: '2022-10-17',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220102,
      user_name: '김철수',
      user_phone: '010-2891-1799',
      booking_date: '2022-10-13',
      booking_time: '14:00',
      categories: '검진',
    },
    {
      id: 220103,
      user_name: '김영희',
      user_phone: '010-5251-9688',
      booking_date: '2022-10-26',
      booking_time: '11:00',
      categories: '검진',
    },
    {
      id: 220104,
      user_name: '이소헌',
      user_phone: '010-5528-7812',
      booking_date: '2022-10-16',
      booking_time: '15:00',
      categories: '검진',
    },
    {
      id: 220105,
      user_name: '조재준',
      user_phone: '010-7732-7154',
      booking_date: '2022-10-28',
      booking_time: '15:00',
      categories: '진료',
    },
    {
      id: 220106,
      user_name: '장동건',
      user_phone: '010-4533-3593',
      booking_date: '2022-10-24',
      booking_time: '13:00',
      categories: '기타',
    },
    {
      id: 220107,
      user_name: '원빈',
      user_phone: '010-5794-1495',
      booking_date: '2022-10-17',
      booking_time: '10:00',
      categories: '진료',
    },
    {
      id: 220108,
      user_name: '송혜교',
      user_phone: '010-6185-1807',
      booking_date: '2022-11-04',
      booking_time: '10:00',
      categories: '기타',
    },
    {
      id: 220109,
      user_name: '전지현',
      user_phone: '010-6570-4052',
      booking_date: '2022-10-14',
      booking_time: '09:00',
      categories: '검진',
    },
    {
      id: 220110,
      user_name: '하지원',
      user_phone: '010-6877-1089',
      booking_date: '2022-10-16',
      booking_time: '14:00',
      categories: '진료',
    },
    {
      id: 220111,
      user_name: '공효진',
      user_phone: '010-6373-0426',
      booking_date: '2022-11-02',
      booking_time: '11:00',
      categories: '기타',
    },
    {
      id: 220112,
      user_name: '차승원',
      user_phone: '010-6876-4723',
      booking_date: '2022-11-03',
      booking_time: '15:00',
      categories: '검진',
    },
    {
      id: 220113,
      user_name: '배두나',
      user_phone: '010-6797-3135',
      booking_date: '2022-11-05',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220114,
      user_name: '현빈',
      user_phone: '010-3505-8447',
      booking_date: '2022-10-13',
      booking_time: '16:00',
      categories: '기타',
    },
    {
      id: 220115,
      user_name: '공유',
      user_phone: '010-6781-8479',
      booking_date: '2022-11-09',
      booking_time: '13:54',
      categories: '진료',
    },
    {
      id: 220116,
      user_name: '손예진',
      user_phone: '010-6346-5350',
      booking_date: '2022-10-29',
      booking_time: '10:00',
      categories: '검진',
    },
    {
      id: 220117,
      user_name: '손석구',
      user_phone: '010-7817-3353',
      booking_date: '2022-10-29',
      booking_time: '11:00',
      categories: '진료',
    },
    {
      id: 220118,
      user_name: '마동석',
      user_phone: '010-6709-4784',
      booking_date: '2022-10-13',
      booking_time: '09:00',
      categories: '진료',
    },
    {
      id: 220119,
      user_name: '윤계상',
      user_phone: '010-6298-1497',
      booking_date: '2022-11-01',
      booking_time: '16:00',
      categories: '기타',
    },
    {
      id: 220120,
      user_name: '손호영',
      user_phone: '010-6252-6309',
      booking_date: '2022-10-13',
      booking_time: '10:00',
      categories: '진료',
    },
    {
      id: 220121,
      user_name: '박준형',
      user_phone: '010-3574-0682',
      booking_date: '2022-10-11',
      booking_time: '13:00',
      categories: '검진',
    },
    {
      id: 220122,
      user_name: '김태우',
      user_phone: '010-6223-2967',
      booking_date: '2022-10-11',
      booking_time: '14:00',
      categories: '검진',
    },
    {
      id: 220123,
      user_name: '임윤아',
      user_phone: '010-5319-1515',
      booking_date: '2022-10-12',
      booking_time: '11:00',
      categories: '검진',
    },
    {
      id: 220124,
      user_name: '김유리',
      user_phone: '010-3522-1113',
      booking_date: '2022-11-09',
      booking_time: '13:00',
      categories: '기타',
    },
    {
      id: 220125,
      user_name: '김태연',
      user_phone: '010-6161-3718',
      booking_date: '2022-10-21',
      booking_time: '09:00',
      categories: '진료',
    },
    {
      id: 220126,
      user_name: '정수정',
      user_phone: '010-4902-7949',
      booking_date: '2022-11-07',
      booking_time: '09:00',
      categories: '검진',
    },
    {
      id: 220127,
      user_name: '티파니',
      user_phone: '010-6116-2558',
      booking_date: '2022-10-10',
      booking_time: '10:00',
      categories: '검진',
    },
    {
      id: 220128,
      user_name: '이서현',
      user_phone: '010-6786-3062',
      booking_date: '2022-10-12',
      booking_time: '14:00',
      categories: '검진',
    },
    {
      id: 220129,
      user_name: '이수만',
      user_phone: '010-6454-8573',
      booking_date: '2022-10-20',
      booking_time: '09:00',
      categories: '진료',
    },
    {
      id: 220130,
      user_name: '카리나',
      user_phone: '010-6181-0297',
      booking_date: '2022-10-22',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220131,
      user_name: '박신혜',
      user_phone: '010-6311-5950',
      booking_date: '2022-10-23',
      booking_time: '11:00',
      categories: '검진',
    },
    {
      id: 220132,
      user_name: '장근석',
      user_phone: '010-6109-0076',
      booking_date: '2022-10-17',
      booking_time: '15:00',
      categories: '기타',
    },
    {
      id: 220133,
      user_name: '이홍기',
      user_phone: '010-6261-9711',
      booking_date: '2022-11-01',
      booking_time: '11:00',
      categories: '기타',
    },
    {
      id: 220134,
      user_name: '김재중',
      user_phone: '010-5543-2710',
      booking_date: '2022-10-17',
      booking_time: '11:00',
      categories: '진료',
    },
    {
      id: 220135,
      user_name: '정윤호',
      user_phone: '010-5583-0259',
      booking_date: '2022-11-02',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220136,
      user_name: '김준수',
      user_phone: '010-4448-3999',
      booking_date: '2022-10-11',
      booking_time: '15:00',
      categories: '검진',
    },
    {
      id: 220137,
      user_name: '심창민',
      user_phone: '724-362-0596',
      booking_date: '2022-10-17',
      booking_time: '17:00',
      categories: '진료',
    },
    {
      id: 220138,
      user_name: '이유천',
      user_phone: '010-6315-9101',
      booking_date: '2022-10-06',
      booking_time: '15:00',
      categories: '진료',
    },
    {
      id: 220139,
      user_name: '김희철',
      user_phone: '010-6279-8207',
      booking_date: '2022-10-08',
      booking_time: '13:00',
      categories: '진료',
    },
    {
      id: 220140,
      user_name: '신동',
      user_phone: '010-6790-4057',
      booking_date: '2022-10-18',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220141,
      user_name: '최시원',
      user_phone: '010-6794-1991',
      booking_date: '2022-11-09',
      booking_time: '14:00',
      categories: '진료',
    },
    {
      id: 220142,
      user_name: '김유진',
      user_phone: '010-6656-8629',
      booking_date: '2022-10-05',
      booking_time: '11:00',
      categories: '기타',
    },
    {
      id: 220143,
      user_name: '이효리',
      user_phone: '010-6344-5375',
      booking_date: '2022-10-07',
      booking_time: '14:00',
      categories: '기타',
    },
    {
      id: 220144,
      user_name: '옥주현',
      user_phone: '010-6788-2445',
      booking_date: '2022-10-13',
      booking_time: '13:00',
      categories: '검진',
    },
    {
      id: 220145,
      user_name: '김이박',
      user_phone: '010-6774-3796',
      booking_date: '2022-10-02',
      booking_time: '14:00',
      categories: '검진',
    },
    {
      id: 220146,
      user_name: '이진희',
      user_phone: '010-6197-7166',
      booking_date: '2022-10-24',
      booking_time: '16:00',
      categories: '진료',
    },
    {
      id: 220147,
      user_name: '정훈조',
      user_phone: '010-6177-9525',
      booking_date: '2022-10-24',
      booking_time: '09:00',
      categories: '기타',
    },
    {
      id: 220148,
      user_name: '정종현',
      user_phone: '010-3541-4716',
      booking_date: '2022-11-05',
      booking_time: '11:00',
      categories: '진료',
    },
    {
      id: 220149,
      user_name: '이제니',
      user_phone: '010-6652-8039',
      booking_date: '2022-10-08',
      booking_time: '10:00',
      categories: '검진',
    },
    {
      id: 220150,
      user_name: '라리사',
      user_phone: '010-6359-7514',
      booking_date: '2022-11-04',
      booking_time: '15:00',
      categories: '검진',
    },
    {
      id: 220151,
      user_name: '이지은',
      user_phone: '010-6723-8851',
      booking_date: '2022-10-10',
      booking_time: '09:00',
      categories: '진료',
    },
    {
      id: 220152,
      user_name: '아이유',
      user_phone: '010-6530-9685',
      booking_date: '2022-11-01',
      booking_time: '15:00',
      categories: '진료',
    },
    {
      id: 220153,
      user_name: '이채은',
      user_phone: '010-6796-8818',
      booking_date: '2022-10-23',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220154,
      user_name: '이진영',
      user_phone: '010-6163-1246',
      booking_date: '2022-11-02',
      booking_time: '14:00',
      categories: '검진',
    },
    {
      id: 220155,
      user_name: '배용준',
      user_phone: '010-6570-4348',
      booking_date: '2022-10-16',
      booking_time: '10:00',
      categories: '기타',
    },
    {
      id: 220156,
      user_name: '이지아',
      user_phone: '010-6188-4630',
      booking_date: '2022-11-03',
      booking_time: '13:00',
      categories: '진료',
    },
    {
      id: 220157,
      user_name: '송중기',
      user_phone: '010-6767-5725',
      booking_date: '2022-10-09',
      booking_time: '14:00',
      categories: '진료',
    },
    {
      id: 220158,
      user_name: '임영웅',
      user_phone: '010-6776-8417',
      booking_date: '2022-11-05',
      booking_time: '15:00',
      categories: '기타',
    },
    {
      id: 220159,
      user_name: '김옥자',
      user_phone: '010-3532-7435',
      booking_date: '2022-10-03',
      booking_time: '16:00',
      categories: '기타',
    },
    {
      id: 220160,
      user_name: '태진아',
      user_phone: '010-6605-1130',
      booking_date: '2022-10-27',
      booking_time: '13:00',
      categories: '검진',
    },
    {
      id: 220161,
      user_name: '장윤정',
      user_phone: '010-6244-0011',
      booking_date: '2022-10-13',
      booking_time: '17:00',
      categories: '진료',
    },
    {
      id: 220162,
      user_name: '송가인',
      user_phone: '010-6547-6895',
      booking_date: '2022-11-04',
      booking_time: '13:00',
      categories: '진료',
    },
    {
      id: 220163,
      user_name: '남도일',
      user_phone: '010-6578-0355',
      booking_date: '2022-10-09',
      booking_time: '16:00',
      categories: '검진',
    },
    {
      id: 220164,
      user_name: '유미란',
      user_phone: '010-6203-9205',
      booking_date: '2022-10-18',
      booking_time: '13:00',
      categories: '검진',
    },
    {
      id: 220165,
      user_name: '김전일',
      user_phone: '010-3544-4021',
      booking_date: '2022-10-26',
      booking_time: '09:00',
      categories: '진료',
    },
    {
      id: 220166,
      user_name: '송대관',
      user_phone: '010-6303-7602',
      booking_date: '2022-11-07',
      booking_time: '11:00',
      categories: '진료',
    },
    {
      id: 220167,
      user_name: '박은빈',
      user_phone: '010-3588-7512',
      booking_date: '2022-10-20',
      booking_time: '11:00',
      categories: '기타',
    },
    {
      id: 220168,
      user_name: '엄정화',
      user_phone: '010-6819-0749',
      booking_date: '2022-11-09',
      booking_time: '09:00',
      categories: '기타',
    },
    {
      id: 220169,
      user_name: '김현정',
      user_phone: '010-6192-3732',
      booking_date: '2022-10-12',
      booking_time: '13:00',
      categories: '진료',
    },
    {
      id: 220170,
      user_name: '김건모',
      user_phone: '010-6522-6377',
      booking_date: '2022-10-29',
      booking_time: '14:00',
      categories: '진료',
    },
    {
      id: 220171,
      user_name: '성시경',
      user_phone: '010-6570-2488',
      booking_date: '2022-10-10',
      booking_time: '15:00',
      categories: '진료',
    },
    {
      id: 220172,
      user_name: '장원영',
      user_phone: '010-6704-5068',
      booking_date: '2022-10-04',
      booking_time: '14:00',
      categories: '기타',
    },
    {
      id: 220173,
      user_name: '안유진',
      user_phone: '010-66817-8383',
      booking_date: '2022-10-17',
      booking_time: '14:00',
      categories: '진료',
    },
    {
      id: 220174,
      user_name: '이수영',
      user_phone: '010-6237-7480',
      booking_date: '2022-10-09',
      booking_time: '11:00',
      categories: '진료',
    },
    {
      id: 220175,
      user_name: '아이린',
      user_phone: '010-6198-2707',
      booking_date: '2022-11-01',
      booking_time: '14:00',
      categories: '기타',
    },
    {
      id: 220176,
      user_name: '신하균',
      user_phone: '010-6678-8803',
      booking_date: '2022-10-04',
      booking_time: '13:00',
      categories: '검진',
    },
    {
      id: 220177,
      user_name: '조정석',
      user_phone: '010-6689-3971',
      booking_date: '2022-10-28',
      booking_time: '13:00',
      categories: '진료',
    },
    {
      id: 220178,
      user_name: '유연석',
      user_phone: '010-6877-8171',
      booking_date: '2022-10-16',
      booking_time: '17:00',
      categories: '진료',
    },
    {
      id: 220179,
      user_name: '정경호',
      user_phone: '010-6181-8368',
      booking_date: '2022-10-24',
      booking_time: '11:00',
      categories: '검진',
    },
    {
      id: 220180,
      user_name: '남궁민',
      user_phone: '010-6555-4076',
      booking_date: '2022-11-08',
      booking_time: '09:00',
      categories: '진료',
    },
  ],
};
